import { Dispatch, SetStateAction, useContext } from 'react'
import { SetMainNavigateContext } from '../context/MainNavigateContext'
import type { MainNavigate } from '../typings/MainNavigate'

export function useSetMainNavigate(): Dispatch<
  SetStateAction<MainNavigate | undefined>
> {
  return useContext(SetMainNavigateContext)!
}
